module.exports = __webpack_public_path__ + "static/img/logo-pl3.46461202.png";